import { ReactNode } from 'react';

type BackgroundDisabledCardFundsProps = {
  isDisabled: boolean;
  children: ReactNode;
};

export const BackgroundDisabledCardFunds = ({
  isDisabled,
  children
}: BackgroundDisabledCardFundsProps) => {
  return (
    <div
      className="tw-relative"
      data-testid={`disabled-background: ${isDisabled}`}
    >
      {isDisabled && (
        <div className="tw-mt-5 tw-absolute tw-inset-0 tw-bg-gray-400 tw-opacity-60 tw-z-20 tw-rounded-md"></div>
      )}
      <div className="tw-relative tw-z-10">{children}</div>
    </div>
  );
};
